import {getAllCity} from "@/api/cinema";
import {getLocation} from '@/utils/getLocation'
export default {
    namespaced: true,
    state: {
        hasMounted:false,
        // 当前城市名字
        cityName: '宁波',
        // cityName: '南通',
        //当前位置的经纬度
        cityPosition: {
            latitude: 0,
            longitude: 0
        }
    },
    getters: {},
    mutations: {
        setCityName(state, data) {
            state.cityName = data;
        },
        setCityPosition(state, data) {
            state.cityPosition = data;
        }
    },
    actions: {
        async getLocation({ commit }){
            let obj = getLocation()
            commit('setCityPosition',obj)
        }

    }
}
